module.exports = __webpack_public_path__ + "img/914.fdc5cb21.png";